export const LIVE_STATUS = {
  READY: 'ready',
  UNPUBLISHED: 'unpublished',
  LIVE: 'live',
  LIVE_STOPPED: 'live_stopped'
}
